import { fetchInstructorReservationsForRange } from "./instructorReservations";
import { buildLessonCardItem } from "./studentReservationCardUtils";
import { mapReservationsToEvents } from "./studentCalendarUtils";

const CALENDAR_RANGE_DAYS = 90;

function attachLessonCardItems(events) {
   return events.map((event, index) => ({
      ...event,
      kind: "lesson",
      typeLabel: "Lecție",
      title: "Lecție",
      cardItem: buildLessonCardItem(event.raw || event, index),
   }));
}

function buildCalendarRangeIso() {
   const now = new Date();
   const start = new Date(now);
   start.setHours(0, 0, 0, 0);
   start.setDate(start.getDate() - CALENDAR_RANGE_DAYS);

   const end = new Date(now);
   end.setHours(23, 59, 59, 999);
   end.setDate(end.getDate() + CALENDAR_RANGE_DAYS);

   return {
      startDateFrom: start.toISOString(),
      startDateTo: end.toISOString(),
   };
}

export async function loadInstructorCalendarEvents(instructor, user) {
   if (!instructor?.id) return [];

   const range = buildCalendarRangeIso();
   const raw = await fetchInstructorReservationsForRange(instructor, user, range);
   return attachLessonCardItems(mapReservationsToEvents(raw));
}

export function getInstructorLessonEvents(events = []) {
   return events.filter((event) => event.kind === "lesson");
}
